module.exports = __webpack_public_path__ + "static/VideoCristianAbrilsub-ff6849da29d11cccc28e7d54125d6af0.mp4";